/**
 * Live password checklist rules used by register / reset UIs.
 * Matches enforce pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,}$/
 */
export function getPasswordRequirementRules(password) {
	const p = String(password ?? "");
	return {
		hasMin: p.length >= 8,
		hasLetterNumber: /[a-zA-Z]/.test(p) && /\d/.test(p),
		// Empty must stay unmet so "no symbols" does not light up before typing.
		onlyAllowed: p.length > 0 && /^[a-zA-Z0-9]*$/.test(p),
	};
}
